import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import React, { memo } from 'react';
import { HookFieldSet } from './HookFieldSet';

import { useWizardFormController } from '../wizard/formHelpers';
import { formatMessageHelper, FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import { localeData } from '../../../locales/data';
import classcat from 'classcat';
import { WizardControllerProps } from './types';
import { useIntl } from 'react-intl';

interface CheckboxFieldProps {
  controllerProps: WizardControllerProps;
  inputProps: CheckboxProps;
  className?: string;
}

export const CheckboxField = memo(
  ({ controllerProps, inputProps: { className, labelElement, labelValues, label, info, disabled } }: CheckboxFieldProps) => {
    const controller = useWizardFormController(controllerProps);

    const onChange = (_: any, { checked }: any) => {
      controller.field.onChange({ target: { value: checked } });
      controller.field.onBlur();
    };

    const intl = useIntl();
    return (
      <HookFieldSet
        id={controllerProps.name}
        className={classcat(['account-wizard-field--span-2', className])}
        controller={controller}
        control={controllerProps.control}
      >
        <div ref={controller.field.ref} className={'checkbox-field__container'}>
          <Checkbox
            disabled={disabled}
            name={controller.field.name}
            checked={!!controller.field.value}
            onChange={onChange}
            label={label ? formatMessageHelper(intl, label as string, labelValues) : undefined}
          />
          {labelElement}
        </div>
        {!!info && (
          <div className="info_small">
            <FormattedMessageHelper tagName="span" id={info} defaultMessage={localeData.en[info]} />
          </div>
        )}
      </HookFieldSet>
    );
  }
);
